import React from 'react';
import CITIES from '../constants/cities';

const today = new Date().toISOString().split('T')[0];
const todayDisplay = new Date().toLocaleDateString('en-IN', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
});

const inputStyle = {
  width: '100%',
  border: '1px solid #e5e1db',
  borderRadius: 9,
  padding: '11px 14px',
  fontSize: 14,
  color: '#1a1a1a',
  outline: 'none',
  background: '#faf9f7',
};

const labelStyle = {
  fontSize: 11,
  letterSpacing: 1,
  textTransform: 'uppercase',
  color: '#999',
  display: 'block',
  marginBottom: 6,
};

function ProjectForm({
  clientName, setClientName,
  exhibition, setExhibition,
  location, setLocation,
  eventDateFrom, setEventDateFrom,
  eventDateTo, setEventDateTo,
}) {
  return (
    <div
      style={{
        background: '#fff',
        borderRadius: 18,
        border: '1px solid #ede9e3',
        padding: '2rem',
        marginBottom: '2rem',
        boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
      }}
    >
      <h3
        style={{
          fontSize: 11,
          letterSpacing: 2,
          textTransform: 'uppercase',
          color: '#aaa',
          marginBottom: '1.5rem',
        }}
      >
        Project Information
      </h3>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: 20,
        }}
      >
        {/* Client Name */}
        <div>
          <label style={labelStyle}>Client Name</label>
          <input
            value={clientName}
            onChange={(e) => setClientName(e.target.value)}
            placeholder="Enter client name"
            style={inputStyle}
          />
        </div>

        {/* Auto-filled date */}
        <div>
          <label style={labelStyle}>Date</label>
          <input
            value={todayDisplay}
            readOnly
            style={{ ...inputStyle, color: '#999', background: '#f5f3f0' }}
          />
        </div>

        {/* Exhibition Name */}
        <div>
          <label style={labelStyle}>Exhibition Name</label>
          <input
            value={exhibition}
            onChange={(e) => setExhibition(e.target.value)}
            placeholder="e.g., India International Trade Fair"
            style={inputStyle}
          />
        </div>

        {/* Location dropdown */}
        <div>
          <label style={labelStyle}>Location</label>
          <select
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            style={{ ...inputStyle, color: location ? '#1a1a1a' : '#aaa', appearance: 'none' }}
          >
            <option value="">Select city…</option>
            {CITIES.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>
        </div>

        {/* Exhibition Date — From / To */}
        <div>
          <label style={labelStyle}>Exhibition Date — From</label>
          <input
            type="date"
            value={eventDateFrom}
            onChange={(e) => setEventDateFrom(e.target.value)}
            min={today}
            style={{ ...inputStyle, color: eventDateFrom ? '#1a1a1a' : '#aaa' }}
          />
        </div>

        <div>
          <label style={labelStyle}>Exhibition Date — To</label>
          <input
            type="date"
            value={eventDateTo}
            onChange={(e) => setEventDateTo(e.target.value)}
            min={eventDateFrom || today}
            style={{ ...inputStyle, color: eventDateTo ? '#1a1a1a' : '#aaa' }}
          />
        </div>
      </div>
    </div>
  );
}

export default ProjectForm;
